export function resolveTourElement(elementId: string): HTMLElement | null {
    // Try data-tour attribute first
    let element = document.querySelector<HTMLElement>(`[data-tour="${elementId}"]`);

    if (element) {
        // Check if element is visible and has area
        if (isElementVisible(element)) {
            return element;
        }
        return null;
    }

    // Try tourId prop (for components like Indicator)
    element = document.querySelector<HTMLElement>(`[tourId="${elementId}"]`);

    if (element && isElementVisible(element)) {
        return element;
    }

    return null;
}

function isElementVisible(element: HTMLElement): boolean {
    // Check if element is hidden
    if (element.offsetHeight === 0 || element.offsetWidth === 0) {
        return false;
    }

    // Check if element or any parent has aria-hidden="true"
    let current: HTMLElement | null = element;
    while (current) {
        if (current.getAttribute('aria-hidden') === 'true') {
            return false;
        }
        if ((current as any).inert === true) {
            return false;
        }
        current = current.parentElement;
    }

    // Check visibility
    const style = window.getComputedStyle(element);
    if (style.visibility === 'hidden' || style.display === 'none') {
        return false;
    }

    return true;
}
